import { isToolUIPart, type UIMessage } from "ai";

type ActivePendingRef = {
  toolCallId: string;
} | null;

function isPendingWriteToolState(
  part: Extract<UIMessage["parts"][number], { toolCallId: string }>
): boolean {
  return (
    part.state === "input-available" ||
    part.state === "approval-requested" ||
    (part.state === "input-streaming" && Boolean(part.input))
  );
}

export function isActivePendingWriteToolPart(
  part: UIMessage["parts"][number],
  activePending: ActivePendingRef
): boolean {
  if (!activePending || !isToolUIPart(part)) return false;
  if (part.toolCallId !== activePending.toolCallId) return false;
  return isPendingWriteToolState(part);
}
